import fetch from '../config/api'

/**
 * 获取首页文博快讯、相关公告(已结)
 */
const News = (language = '1', type = '1') => fetch('/news/index', {
    p: 'wx',
    language,
    type,
});
/**
 * 文博资讯和相关公告, 大事件， 改扩建工程列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type} 1 表示文博资讯(已结) 2 表示相关公告(已结) 3 表示大事件(已结) 4 表示改扩建工程(已结) 5 表示政策法规(已结) 6 表示党政务公开(已结), 7 表示文物捐赠(已结)
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */

const NewsList = (type = '1',language = '1', num = '0', take = '10') => fetch('/news/news_list', {
    p: 'wx',
    language,
    type,
    skip: num * take, //从第几个开始
    take //取几条数据
});
/**
 * 获取 1 文博资讯 2 相关公告 3 大事件 4 改扩建工程 5 政策法规 6 党政务公开, 7 文物捐赠 详情(已结)
 */
const NewsDetail = (language = '1', news_id) => fetch('/news/news_detail', {
    p: 'wx',
    language,
    news_id,
});


/**
 * 首页展览(专题展览和特展回眸每项最多返回3条)(已结)
 */
const ExhibitionIndex = (language = '1') => fetch('/exhibition/index', {
    p: 'wx',
    language,
});

/**
 * 全景漫游(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const Allscene = (language = '1') => fetch('/exhibit/all_scene', {
    p: 'wx',
    language,
});
/**
 * 全景漫游(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const AllsceneList = (language = '1') => fetch('/exhibit/all_scene_list', {
    p: 'wx',
    language,
});
/**
 * 首页珍品赏析接口(最多返回4条)(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const Treasures = (language = '1') => fetch('/exhibit/index', {
    p: 'wx',
    language,
});


/**
 * 详情内容
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type} 1 表示开闭馆时间 2表示交通路线 3表示历史沿革(已结) 4表示藏馆简介(已结) 5表示馆长致辞(已结) 6表示馆长信箱 7票务预约简介 8 文物征集(已结) 9 联合工作站简介
 */
const MuseumBrief = (language = '1', type = '1') => fetch('/museum_brief/detail', {
    p: 'wx',
    language,
    type
});
const banner_for_index = (language = '1') => fetch('/banner_for_index', {
    p: 'wx',
    language
});
const time_desc = (language = '1') => fetch('/time_desc', {
    p: 'wx',
    language
});
 const activityForIndex = (language = '1') => fetch('/activity/activityForIndex', {
    p: 'wx',
    language,
});
 const incr_websit = () => fetch('/incr_websit', {
    p: 'wx'
});

export default {
    News,
    NewsDetail,
    NewsList,
    ExhibitionIndex,
    Allscene,
    AllsceneList,
    Treasures,
    MuseumBrief,
    banner_for_index,
    time_desc,
    activityForIndex,
    incr_websit
}